import React from 'react';
import './Popover.css';

const Popover = ({ children, visible, position = 'top', style = {} }) => {
  if (!visible) return null;

  return (
    <div className={`popover-container ${position}`} style={style}>
      <div className="popover-arrow" />
      <div className="popover-content">
        {children}
      </div>
    </div>
  );
};

export default Popover;
